import i from 'i18next'
import { motion } from 'framer-motion'
import { mobileMenuMaxWidth } from 'constants/styles'
import Flyout from './Flyout'
import { BENELUX_FREE } from './Cart'

type FlyoutProps = {
	active: boolean
	onClose: () => void
}

export default function Shipping({ active, onClose }: FlyoutProps ) {
	const fadeIn = {
		hidden: { opacity: 0 },
		visible: { opacity: 1 },
	}

	return (
		<Flyout active={active} onClose={onClose}>
			<article className="rates">
				<motion.h2 variants={fadeIn}>
					{i.t( 'nav.shipping.title' )}
				</motion.h2>
				<Hr />
				<motion.div variants={fadeIn}>
					<div>{i.t( 'nav.shipping.zone1.name' )}</div>
					<div>
						{i.t( 'nav.shipping.zone1.rates', { threshold: BENELUX_FREE })}
					</div>
				</motion.div>
				{/* <Hr />
				<motion.div variants={fadeIn}>
					<div>{i.t( 'nav.shipping.zone2.name' )}</div>
					<div>{i.t( 'nav.shipping.zone2.rates' )}</div>
				</motion.div> */}
			</article>
			<style jsx>{`
				.rates :global( h2 ) {
					font-size: 15px;
					color: #8A8F95;
				}
				.rates {
					width: 100%;
				}
				.rates :global( > div ) {
					white-space: pre-wrap;
					padding-bottom: 35px;
					display: flex;
					justify-content: space-between;
					gap: 24px;
				}
				@media ( max-width: ${mobileMenuMaxWidth}px ) {
					.rates :global( > div ) {
						flex-wrap: wrap;
						padding-bottom: 0;
					}
					.rates :global( > div > div ) {
						width: 100%;
						margin-bottom: 1em;
					}
				}
				.rates :global( > div > div ) {
				}
			`}</style>
		</Flyout>
	)
}

const Hr = () => (
	<motion.hr
		initial={{ scaleX: 0 }}
		variants={{
			hidden: { scaleX: 0 },
			visible: { scaleX: 1 },
		}}
		transition={{
			duration: 1,
			ease: [ 0.43, 0.13, 0.23, 0.96 ],
			delay: 0.5,
		}}
		style={{
			height: 1,
			margin: '35px 0',
			borderStyle: 'none',
			backgroundColor: '#E0E4E9',
			transformOrigin: '0% 0%',
		}}
	/>
)
